/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ index: NonNullable<unknown> }} Work_Order_Import_Status_Importing_TrackInputs */



/**
* | output |
* | --- |
* | "Importing track {index}" |
*
* @param {Work_Order_Import_Status_Importing_TrackInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const work_order_import_status_importing_track = /** @type {((inputs: Work_Order_Import_Status_Importing_TrackInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Order_Import_Status_Importing_TrackInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Importation de la piste ${i?.index}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Importiere Track ${i?.index}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Importazione della traccia ${i?.index}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Импорт трека ${i?.index}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Importando pista ${i?.index}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`正在导入轨道 ${i?.index}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`トラック ${i?.index} をインポートしています`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`ट्रैक ${i?.index} आयात किया जा रहा है`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Importando faixa ${i?.index}`)
	return /** @type {LocalizedString} */ (`Importing track ${i?.index}`)
});